import { useState, useEffect } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { MainState, useAppDispatch, useAppSelector } from '../../../../store/store';
import './CampAlliesInfo.scss';
import BaseButton from '../../../ui/BaseButton';
import CampAlliesLvlBar from './CampAlliesLvlBar';
import { campSlice } from '../../../../store/reducers/campReducer';

// ? temp import
import { skillsImgArr } from '../../../../tempDB';
import { setAllyNewLvl } from '../../../../controllers/allyController';
import ImgWithFallback from '../../../ui/ImgWithFallback';

const CampAlliesInfo = () => {
    // redux const
    const currensy = useAppSelector(state => state.userReducer.character.getInventory().getCurrensies())
    const mainCharacter = useAppSelector(state => state.userReducer.character)
    const dispatch = useAppDispatch()
    const { setIsAllyActive } = campSlice.actions
    // redux selector of ally
    const alliesSelector = createSelector(
        (state: MainState) => state.campReducer.allies,
        (state: MainState) => state.campReducer.activeAllyIndex,
        (allies, activeAllyIndex) => {
            return allies[activeAllyIndex]
        }
    )
    const ally = useAppSelector(alliesSelector)
    // state const
    const [allyLvl, setAllyLvl] = useState(ally.getLevel().curruntLevel)

    // ? temp const
    const allySkills = skillsImgArr[1]
    // ? end temp const

    useEffect(() => {
        setAllyLvl(ally.getLevel().curruntLevel)
    }, [ally])

    const handleSetAllyActive = () => {
        if (!ally.getIsActive()) {
            mainCharacter.addActiveAlly(ally)
            dispatch(setIsAllyActive())
            mainCharacter.allyMod('hp')
        }
    }

    const handleSetAllyInactive = () => {
        if (ally.getIsActive()) {
            mainCharacter.removeActiveAlly(ally)
            dispatch(setIsAllyActive())
        }
    }

    function lvlUp() {
        if (allyLvl === ally.getLevel().maxLevel) return

        setAllyNewLvl(mainCharacter, ally)
        setAllyLvl(ally.getLevel().curruntLevel)
    }

    const allyInfo = {
        allyFullImg: ally.getImg(),
        allyName: ally.getName(),
        allyProfession: ally.getProfession(),
        itemToLvlUpImg: ally.getItemToLevelUp().img,
        itemToLvlUpName: ally.getItemToLevelUp().name,
        itemToLvlUpPlayerHave: currensy[ally.getItemToLevelUp().id] ? currensy[ally.getItemToLevelUp().id]?.amount : 0,
        itemAmountToLevelUp: ally.getItemToLevelUp().amountToLevelUp,
        allyLvlUpButton:
            currensy[ally.getItemToLevelUp().id]?.amount >= ally.getItemToLevelUp().amountToLevelUp && allyLvl !== ally.getLevel().maxLevel ?
                (<div className="about__needs-lvlup-plus" onClick={lvlUp}></div>) : null,
        allyBountyName: ally.getBounty().name,
        allyBountyValue: ally.getBounty().value[ally.getLevel().curruntLevel + 1],
        allyBountyMaxBonus: ally.getBounty().value[ally.getLevel().maxLevel]
    }

    return (
        <div className="camp-allies__info" key={crypto.randomUUID()}>
            <div className="camp-allies__info-img adaptive-img-contain">
                <ImgWithFallback
                    src={allyInfo.allyFullImg.webp}
                    fallbackSrc={allyInfo.allyFullImg.img} />
            </div>
            <div className="camp-allies__info-body info__content">
                <div className="info__content-title">
                    <h3>{allyInfo.allyName}</h3>
                    <span>/</span>
                    <h3> {allyInfo.allyProfession}</h3>
                    <span>/</span>
                    <h3>lvl {allyLvl}</h3>
                </div>
                <div className="info__content-about about">
                    <p>Give me thats items for lvl up</p>
                    <div className="about__needs">
                        <div className="about__needs-img adaptive-img-cover">
                            <ImgWithFallback
                                src={allyInfo.itemToLvlUpImg.webp}
                                fallbackSrc={allyInfo.itemToLvlUpImg.img} />`
                        </div>
                        <p className='about__needs-item-name'>
                            {allyInfo.itemToLvlUpName}
                        </p>
                        <p className='about__needs-item-amount'>
                            {allyInfo.itemToLvlUpPlayerHave}
                            <span>/</span>
                            {allyInfo.itemAmountToLevelUp}
                        </p>
                        <div className="about__needs-lvlup">
                            {allyInfo.allyLvlUpButton}
                        </div>
                    </div>
                    <p className='about__needs-nextlvl'>
                        At the next level will be + <strong>{allyInfo.allyBountyValue}</strong> to <strong>{allyInfo.allyBountyName}</strong>
                    </p>
                    <div className="about__maxlvl">
                        <p>If lvl max, unlock this skills and max bonus to <strong>{allyInfo.allyBountyName}</strong> <strong>{allyInfo.allyBountyMaxBonus}</strong></p>
                        {/* <ul className='about__maxlvl-skills'>
                            {allySkills.map((skill, i) => {
                                return (
                                    <li className="about__maxlvl-skill adaptive-img-cover" key={i}>
                                        <img src={skill.img} alt="img" />
                                    </li>
                                )
                            })}
                        </ul> */}
                    </div>
                </div>
                <CampAlliesLvlBar allyLvl={allyLvl} allyMaxLvl={ally.getLevel().maxLevel} />
                {/* className='camp-allies__delete-btn' */}
                <div className="camp-allies__btns">
                    <BaseButton name='Make inactive' onClick={handleSetAllyInactive} />
                    <BaseButton name='Make active' onClick={handleSetAllyActive} />
                </div>
            </div>
        </div>
    );
};

export default CampAlliesInfo;